// 时间分隔块 —— 用于消息流："今天 / 昨天 / 5月25日"

interface TimeDividerProps {
  ts: number;
}

export function TimeDivider({ ts }: TimeDividerProps) {
  return (
    <li className="time-divider" aria-hidden>
      <span>{formatDivider(ts)}</span>
    </li>
  );
}

/** 给一条消息的时间生成"日期分隔块"标签 */
export function formatDivider(ts: number): string {
  const d = new Date(ts);
  const today = startOfDay(new Date());
  const that = startOfDay(d);
  const diff = Math.round((today.getTime() - that.getTime()) / 86_400_000);
  if (diff === 0) return "今天";
  if (diff === 1) return "昨天";
  if (diff < 7) return ["", "", "周二", "周三", "周四", "周五", "周六", "周日"][d.getDay()] || `${d.getMonth() + 1}月${d.getDate()}日`;
  return `${d.getMonth() + 1}月${d.getDate()}日`;
}

/** 判断两个时间戳是否应在同一日期分隔块下 */
export function sameDay(a: number, b: number): boolean {
  return startOfDay(new Date(a)).getTime() === startOfDay(new Date(b)).getTime();
}

function startOfDay(d: Date): Date {
  const r = new Date(d);
  r.setHours(0, 0, 0, 0);
  return r;
}
